export default function CTASection() {
  return (
    <section className="flex flex-col lg:flex-row">
      {/* Left - Image */}
      <div className="lg:w-1/2 h-[350px] lg:h-[500px] relative overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20fashion%20display%20with%20neutral%20toned%20clothing%20elegantly%20draped%20on%20wooden%20rack%2C%20soft%20morning%20sunlight%20streaming%20through%20window%2C%20peaceful%20boutique%20atmosphere%2C%20earthy%20aesthetic%2C%20editorial%20quality%2C%20no%20text&width=900&height=800&seq=cta-left-v3&orientation=portrait"
          alt="CSSBuy Spreadsheet - Compras da China"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/10"></div>
        <div className="absolute bottom-0 left-0 p-8">
          <span className="text-background-50/80 text-xs font-medium uppercase tracking-wider">
            CSSBuy Spreadsheet
          </span>
          <h3 className="font-heading text-4xl md:text-5xl font-bold text-background-50 leading-tight mt-2">
            Compre da
            <br />
            China com
            <br />
            Facilidade
          </h3>
        </div>
      </div>

      {/* Right - CTA */}
      <div className="lg:w-1/2 flex flex-col items-center justify-center py-16 px-6 md:px-16 bg-background-50">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 text-center mb-6 leading-tight">
          Compre na China
          <br />
          com Segurança
        </h2>
        <p className="text-foreground-600 text-base text-center max-w-md mb-4 leading-relaxed">
          Acesse nossa planilha completa com mais de 1000 produtos organizados por categorias. Preços atualizados, links verificados e todo o suporte que você precisa para comprar da China.
        </p>
        <p className="text-foreground-500 text-sm text-center max-w-md mb-8">
          CSSBuy atua como agente intermediário verificando a qualidade dos produtos antes do envio internacional. Segurança e transparência em cada etapa.
        </p>
        <a
          href="https://kaspreadsheet.com/"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-base cursor-pointer hover:bg-primary-600 transition-all whitespace-nowrap"
        >
          Acessar CSSBuy Spreadsheet
          <i className="ri-arrow-right-line text-lg"></i>
        </a>
      </div>
    </section>
  );
}